import {WlIntegerInput} from "./integerInput.component";
import { defineWebComponent } from "../webcomponents-utils";

export * from './integerInput.component';
export default WlIntegerInput;

defineWebComponent('wl-integer-input', WlIntegerInput);
